<template>
  <v-layout>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <div
          class="route-title"
          v-on="on"
        >
          <h3
            class="subheading font-weight-bold"
            @click="routeShippingsDialog = true"
          >
            {{ route ? route.title : "" }}
          </h3>
        </div>
      </template>
      <span>Нажмите для управления порядком поставок</span>
    </v-tooltip>

    <v-dialog
      v-if="routeShippingsDialog"
      v-model="routeShippingsDialog"
      persistent
    >
      <v-card class="pa-2">
        <v-card-title>
          <v-layout
            row
            wrap
            align-center
            justify-end
          >
            <h3 class="title font-weight-bold pa-1">
              {{ route ? route.title : "" }}
            </h3>
            <v-divider
              vertical
              class="mx-4"
            />
            <v-flex>
              <span class="subheading">Направление: </span>
              <span class="subheading font-weight-bold">{{
                route.direction.title
              }}</span>
            </v-flex>
            <v-flex>
              <span class="subheading">Дата погрузки: </span>
              <span class="subheading font-weight-bold">{{
                routeLoadingDate | date
              }}</span>
            </v-flex>
            <v-flex>
              <span class="subheading">Объем: </span>
              <span class="subheading font-weight-bold">{{
                route.summaryInfo ? route.summaryInfo.volume.toFixed(2) : 0
              }}</span>
            </v-flex>
            <v-flex>
              <span class="subheading">Вес: </span>
              <span class="subheading font-weight-bold">{{
                route.summaryInfo ? route.summaryInfo.weight.toFixed(2) : 0
              }}</span>
            </v-flex>
            <v-flex v-if="!route.draftId">
              <span class="subheading">Количество мест: </span>
              <span class="subheading font-weight-bold">{{
                route.summaryInfo ? route.summaryInfo.cargoPlaces : 0
              }}</span>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn
                small
                @click="routeShippingsDialog = false"
              >
                Отмена
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-card-text
          class="pa-2"
          style="overflow: auto;"
        >
          <v-tabs slider-color="primary">
            <v-tab>Поставки</v-tab>
            <v-tab>Способ упаковки</v-tab>
            <v-tab>Грузы поставок</v-tab>
            <v-tab-item>
              <v-data-table
                :loading="loading"
                :items="route.phases"
                :headers="headers"
                hide-actions
                class="mb-1 v-data-table--fixed-header"
                style="max-height: 500px; height: auto; overflow: auto"
              >
                <template
                  slot="headers"
                  slot-scope="props"
                >
                  <tr>
                    <th
                      v-for="(header, index) in props.headers"
                      :key="index"
                      class="route-shippings-headers"
                      :style="{
                        'min-width': `${
                          header.minWidth ? header.minWidth : 40
                        }px`,
                        width: `${header.minWidth ? header.minWidth : 40}px`
                      }"
                    >
                      {{ header.title }}
                    </th>
                  </tr>
                </template>
                <template
                  slot="items"
                  slot-scope="props"
                >
                  <template v-if="route.phases.length > 0">
                    <TableRow
                      :headers="headers"
                      :shipping="props.item"
                      :is-familiarized-show="false"
                    >
                      <template
                        v-slot:prepend-cell
                        :item="props.item"
                      >
                        <v-layout>
                          <span @click="openPhaseDialog(props.item)">
                            <TableCell
                              v-if="props.item.hasUnreadNotes"
                              icon="mail"
                              tooltip="Новый комментарий"
                              color="green"
                              :is-small="true"
                            />
                          </span>
                          <v-icon
                            small
                            :disabled="route.phases.indexOf(props.item) === 0"
                            @click="moveUp(props.item)"
                          >
                            arrow_upward
                          </v-icon>
                          <v-icon
                            small
                            :disabled="
                              route.phases.indexOf(props.item) ===
                                route.phases.length - 1
                            "
                            @click="moveDown(props.item)"
                          >
                            arrow_downward
                          </v-icon>
                        </v-layout>
                      </template>
                      <template
                        v-slot:uppend-cell
                        :item="props.item"
                      >
                        <MenuRowActions
                          v-if="isPickup(props.item.phaseType.id)"
                          :list="rowActions"
                          :value="props.item"
                          :index="route.phases.indexOf(props.item)"
                          :last-index="route.phases.length - 1"
                          :is-route-shippings-dialog-open="true"
                          @removePhase="removePhase"
                          @editPhase="openPhaseDialog"
                        />
                      </template>
                    </TableRow>
                  </template>
                  <template v-else>
                    <tr>
                      <td
                        :colspan="props.headers.length"
                        style="text-align:center;background-color:#fff;"
                      >
                        Нет данных
                      </td>
                    </tr>
                  </template>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item>
              <PackagesGroupedTable
                :route-packages="packagesItems"
                :route-id="route.routeId"
                @change="updatePackages"
              />
            </v-tab-item>
            <v-tab-item>
              <ShippingsPackagesTable
                :shippings-packages="shippingsPackages"
                :route-id="route.routeId"
                @change="updatePackages"
              />
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="phasesEditorDialog"
      v-model="phasesEditorDialog"
      width="1200"
      persistent
    >
      <v-card>
        <PickUpEditor
          v-if="isPickup(activePhase.value)"
          v-model="editingPhase"
          :disabled="!isCanEditPhase"
          :from-route="true"
          :user="currentUser"
          @cancel="closePhaseDialog"
          @readComments="markAsReadCommentsInPhase"
          @add-comment="updateComment"
        />
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import TableRow from "./TableRow.vue";
import PickUpEditor from "../../shippings/components/phases/PickUpEditor.vue";
import TableCell from "../../../components/TableCell.vue";
import PackagesGroupedTable from "../../routes/components/packages/PackagesGroupedTable.vue";
import ShippingsPackagesTable from "../../routes/components/packages/ShippingsPackagesTable.vue";
import arrayMove from "array-move";
import {
  changeItemPosition,
  getPackages,
  deleteItem,
  getShippingsPackages,
} from "../../../backend/routesApi.js";
import { packages } from "../../package-types/packages.js";
import groupedTableHeaders from "../../routes/components/packages/grouped-table-headers.js";
import groupedTableGroups from "../../routes/components/packages/grouped-table-groups.js";
import groupedTableSubGroups from "../../routes/components/packages/grouped-table-subgroups.js";
import { deleteShippingFromRouteDraft } from "../../../backend/routesPlanningApi.js";
import { getPhaseId } from "../../../backend/phasesApi.js";
import { phaseStates } from "../../shippings/components/phases/shipping-phase-states.js";
import { ePhaseTypes as phaseTypes } from "../../shippings/components/phases/shipping-phase-types.js";
import { userRoles } from "../../../enums/user-roles.js";
import auth from "../../../auth.js";

export default {
  components: {
    TableRow,
    PickUpEditor,
    TableCell,
    PackagesGroupedTable,
    ShippingsPackagesTable,
  },
  props: ["route"],
  data() {
    return {
      routeShippingsDialog: false,
      packagesGroups: groupedTableGroups,
      packagesSubGroups: groupedTableSubGroups,
      packagesHeaders: groupedTableHeaders,
      packagesItems: [],
      editingPhase: null,
      activePhase: "",
      phasesEditorDialog: false,
      isCanEditPhase: false,
      rowActions: [
        {
          title: "Изменить звено",
          name: "editPhase",
          action: this.openPhaseDialog,
          type: "icon",
          icon: "edit",
          disabled: false,
        },
        {
          title: "Удалить",
          name: "removePhase",
          action: this.removePhase,
          type: "icon",
          icon: "delete",
          disabled: false,
        },
      ],
      loading: false,
      shippingsPackages: [],
    };
  },
  computed: {
    headers() {
      const visibleColumns = this.$store.getters["routePlanning/headers"];
      return visibleColumns.filter(
        c =>
          c.name !== "route" &&
          (!Object.prototype.hasOwnProperty.call(c, "visible") || c.visible) &&
          c.name !== "isFamiliarized",
      );
    },
    routeLoadingDate() {
      const routeShippingsLoadingDates = [];
      this.route.phases.forEach(s => {
        if (s.carLoadingDate && s.carLoadingDate.fact) {
          routeShippingsLoadingDates.push(this.moment(s.carLoadingDate?.fact));
        } else {
          return;
        }
      });
      if (routeShippingsLoadingDates.length) {
        return this.moment.min(routeShippingsLoadingDates).format();
      } else {
        return null;
      }
    },
    packageTypes() {
      return packages;
    },
    planningData() {
      return this.$store.getters["routePlanning/getPlanningData"];
    },
    currentUser() {
      return auth.getUser();
    },
    isAdmin() {
      return !!this.currentUser.roles.find(r => r.id === userRoles.Admin);
    },
    isUserCanEditPhase() {
      if (
        this.currentUser.roles.find(
          r => r.id === userRoles.Logist || r.id === userRoles.Admin,
        )
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    routeShippingsDialog(value) {
      if (!value) {
        return;
      }
      this.getPackages();
      this.getShippingsPackages();
    },
  },
  methods: {
    async moveUp(item) {
      const index = this.route.phases.indexOf(
        this.route.phases.find(s => s.phaseId === item.phaseId),
      );
      const indexTo = index - 1 > -1 ? index - 1 : 0;
      this.route.phases = arrayMove(this.route.phases, index, indexTo);
      if (item.route?.id && !this.route.draftId) {
        this.loading = true;
        await changeItemPosition(item.route.id, item.routeItemId, indexTo);
        this.loading = false;
        this.showInfo("Порядок звеньев в маршруте изменен");
      }
    },
    async moveDown(item) {
      const index = this.route.phases.indexOf(
        this.route.phases.find(s => s.phaseId === item.phaseId),
      );
      this.route.phases = arrayMove(this.route.phases, index, index + 1);
      if (item.route?.id && !this.route.draftId) {
        this.loading = true;
        await changeItemPosition(item.route.id, item.routeItemId, index + 1);
        this.loading = false;
        this.showInfo("Порядок звеньев в маршруте изменен");
      }
    },
    async removePhase(phase) {
      this.loading = true;
      const phases = [...this.planningData];
      if (phase.route) {
        await deleteItem(phase.route.id, phase.routeItemId);
        phases.forEach(i => {
          if (i.phaseId === phase.phaseId) {
            i.routeColor = "";
            i.route = null;
          }
        });
        this.$store.commit("routePlanning/setPlanningData", phases);
      } else if (phase.draft) {
        await deleteShippingFromRouteDraft(phase.draft.id, phase.phaseId);
        phases.forEach(i => {
          if (i.phaseId === phase.phaseId) {
            i.routeColor = "";
            i.draft = null;
          }
        });
        this.$store.commit("routePlanning/setPlanningData", phases);
      }
      await this.$store.dispatch("routePlanning/getPlanningRoutes");
      this.loading = false;
      this.showInfo("Звено удалено");
    },
    async openPhaseDialog(phase) {
      this.activePhase = {
        value: phase.phaseType.id,
        title: this.isPickup(phase.phaseType.id) ? "Заезд" : "",
      };
      this.loading = true;
      this.editingPhase = await getPhaseId(phase.shipping.id, phase.phaseId);
      this.$store.commit("shipping/setId", phase.shipping.id);
      if (
        this.editingPhase.route &&
        this.currentUser.employeeId === this.route.logist?.id
      ) {
        this.editingPhase.comments.forEach(c => {
          if (c.author.id === this.currentUser.id) {
            c.isReaded = true;
          }
        });
      } else {
        this.editingPhase.comments.forEach(c => (c.isReaded = true));
      }
      if (
        this.isAdmin ||
        (this.isUserCanEditPhase &&
          phase &&
          !phase.inCar &&
          this.editingPhase.state !== phaseStates.DONE)
      ) {
        this.isCanEditPhase = true;
      } else {
        this.isCanEditPhase = false;
      }
      this.loading = false;
      this.phasesEditorDialog = true;
    },
    closePhaseDialog() {
      this.editingPhase = null;
      this.phasesEditorDialog = false;
    },
    isPickup(phaseTypeId) {
      return phaseTypeId === phaseTypes.PICKUP;
    },
    markAsReadCommentsInPhase() {
      const items = this.$store.getters["routePlanning/planningRoutes"];
      items.forEach(i =>
        i.phases.forEach(p => {
          if (p.phaseId === this.editingPhase.id) {
            p.hasUnreadNotes = false;
          }
        }),
      );
      this.$store.commit("routePlanning/setPlanningRoutes", items);
    },
    updateComment(comments) {
      this.editingPhase.comments = comments;
    },
    async getPackages() {
      if (this.route.draftId) {
        return;
      }
      this.packagesItems = await getPackages(this.route.routeId);
    },
    async getShippingsPackages() {
      if (this.route.draftId) {
        return;
      }
      this.shippingsPackages = await getShippingsPackages(this.route.routeId);
    },
    async updatePackages() {
      await this.getPackages();
      await this.getShippingsPackages();
    },
  },
};
</script>
<style>
.route-title:hover {
  background: rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
.route-shippings-headers {
  white-space: pre-line;
  text-align: left;
}
</style>
